import AllSessions from "@/components/AllSessions";
import { useAuth } from "@/contexts/AuthContext";

const SessionsPage = () => {
  const { user } = useAuth();
  const companyId = user?.role === "ADMIN" ? user?.companyId : null;

  return <AllSessions companyId={companyId} />;
};

export default SessionsPage;
